import React from 'react';

const AboutSection = () => {
  const pills = [
    { label: 'Client Focused', icon: 'fas fa-user-check', color: '#6C63FF' },
    { label: 'AI First Approach', icon: 'fas fa-microchip', color: '#00D4FF' },
    { label: 'Secure & Scalable', icon: 'fas fa-shield-virus', color: '#10B981' },
    { label: 'Quality Driven', icon: 'fas fa-award', color: '#A78BFA' },
  ];

  return (
    <section
      id="about"
      style={{
        padding: '64px 0',
        position: 'relative',
        zIndex: 2,
        background: 'linear-gradient(180deg, #060816 0%, #0B0F24 100%)',
      }}
    >
      <div className="ht-container">
        <div className="hero-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: '48px', alignItems: 'center' }}>
          
          {/* LEFT COLUMN: About Text */}
          <div style={{ gridColumn: 'span 6' }} className="about-left">
            <span
              style={{
                fontSize: '0.85rem',
                fontWeight: 800,
                color: '#00D4FF',
                textTransform: 'uppercase',
                letterSpacing: '0.15em',
                display: 'block',
                marginBottom: '12px',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              }}
            >
              ABOUT HUNGRY TOP TECHNOLOGIES
            </span>

            <h2
              style={{
                fontSize: 'clamp(1.9rem, 4.2vw, 3.2rem)',
                lineHeight: 1.18,
                fontWeight: 800,
                color: '#FFFFFF',
                marginBottom: '24px',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                letterSpacing: '-0.02em',
                wordBreak: 'break-word',
              }}
            >
              Your Technology Partner for <br className="desktop-br" />
              <span className="text-gradient-primary">Innovation and Growth</span>
            </h2>

            <p style={{ fontSize: '1.05rem', color: '#A3A8B8', lineHeight: 1.7, marginBottom: '20px', fontFamily: "'Inter', sans-serif" }}>
              Recognized as the premier <strong>best software company in Kolkata, West Bengal</strong>, Hungry Top Technologies develops enterprise-grade software products and provides end-to-end digital transformation services worldwide.
            </p>

            <p style={{ fontSize: '0.98rem', color: '#94A3B8', lineHeight: 1.65, marginBottom: '36px', fontFamily: "'Inter', sans-serif" }}>
              We combine deep engineering experience, artificial intelligence, and cloud-native architecture to build high-performance products that solve real-world industry challenges for global clients.
            </p>

            {/* Feature Pillars Grid */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '16px',
              }}
              className="about-pills-grid"
            >
              {pills.map((pill, idx) => (
                <div
                  key={idx}
                  className="glass-card"
                  style={{
                    padding: '16px 20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px',
                    borderRadius: '16px',
                    background: 'rgba(255, 255, 255, 0.03)',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = `${pill.color}80`;
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.06)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.08)';
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                  }}
                >
                  <div
                    style={{
                      width: '42px',
                      height: '42px',
                      borderRadius: '12px',
                      background: `${pill.color}20`,
                      border: `1px solid ${pill.color}50`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: pill.color,
                      fontSize: '1.1rem',
                      boxShadow: `0 0 15px ${pill.color}30`,
                      flexShrink: 0,
                    }}
                  >
                    <i className={pill.icon}></i>
                  </div>
                  <span style={{ fontSize: '0.95rem', fontWeight: 700, color: '#FFFFFF', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                    {pill.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT COLUMN: Enterprise Office HQ Visual */}
          <div style={{ gridColumn: 'span 6', position: 'relative' }} className="about-right">
            <div
              className="glass-card"
              style={{
                borderRadius: '24px',
                overflow: 'hidden',
                position: 'relative',
                border: '1px solid rgba(108, 99, 255, 0.3)',
                boxShadow: '0 25px 60px rgba(0, 0, 0, 0.6)',
              }}
            >
              <img
                src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80"
                alt="Hungry Top Technologies Enterprise HQ"
                style={{ width: '100%', height: '420px', objectFit: 'cover', display: 'block', filter: 'brightness(0.85) contrast(1.1)' }}
              />

              {/* Gradient Overlay */}
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(180deg, rgba(6, 8, 22, 0.2) 0%, rgba(6, 8, 22, 0.88) 100%)',
                }}
              />

              {/* Floating Founded Badge */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '24px',
                  right: '24px',
                  background: 'linear-gradient(135deg, #6C63FF 0%, #8B5CF6 100%)',
                  padding: '16px 24px',
                  borderRadius: '20px',
                  boxShadow: '0 10px 30px rgba(108, 99, 255, 0.5)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <span style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(255, 255, 255, 0.85)', fontWeight: 700 }}>
                  Founded
                </span>
                <span style={{ fontSize: '2rem', fontWeight: 900, color: '#FFFFFF', lineHeight: 1, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  2021
                </span>
              </div>

              {/* Top HQ Location Tag */}
              <div
                style={{
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  background: 'rgba(6, 8, 22, 0.88)',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',
                  padding: '8px 16px',
                  borderRadius: '12px',
                  border: '1px solid rgba(0, 212, 255, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <i className="fas fa-building" style={{ color: '#00D4FF', fontSize: '0.85rem' }}></i>
                <span style={{ fontSize: '0.8rem', color: '#FFF', fontWeight: 700, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  Kolkata, WB, India
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .about-pills-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default AboutSection;


